const initialState = () => ({
    isSupervisor: false,
    sprints: [],
    sprintsReviewTasks: [],
    sprintDetails: [],
    selectedSprint: 0,
    missionSprints: [],
    newMissionSprint: {
      name: null,
      category: null,
      location_id: [],
      role_id: null,
      role_franchise_id: null,
      assigned_to: null,
      priority: 1,
      end_date: null,
      start_date: null,
      tasks: [],
      type: null,
      review_time: { label: '1 día', value: 24 },
      have_review: false,
      review_in_execution: false,
      have_supervisor: false,
      reviewer_role_id: null,
      reviewers: [],
      supervisors: []
    },
    sprintTasks: [],
    semaphore: {
      red: { min: null, max: null, color: '#E64119', name: 'Malo' },
      amber: { min: null, max: null, color: '#FCDB54', name: 'Regular' },
      green: { min: null, max: null, color: '#8DBF66', name: 'Bueno' }
    },
    selectedSupervisors: [],
    sprintPagination: {
      page: 1,
      rowsPerPage: 7,
      rowsNumber: 0
    },
    pagination: {},
    status: null,
    loading: true
})

export default initialState
